<div class="modal-header-row">
  <h5 class="mb-0">{{ editingImage ? 'Edit Image' : 'Add Image' }}</h5>
  <button class="btn-close" (click)="cancel()"></button>
</div>

<div class="modal-body-content">

  <div class="row mb-3">
    <div class="col-7">
      <label class="form-label">Name</label>
      <input type="text" class="form-control" [(ngModel)]="formName" placeholder="e.g. Clara" />
    </div>
    <div class="col-5">
      <label class="form-label">Age</label>
      <input type="number" class="form-control" [(ngModel)]="formAge" placeholder="e.g. 24" min="18" max="99" />
    </div>
  </div>
  <div class="mb-3">
    <label class="form-label">Message</label>
    <textarea class="form-control" [(ngModel)]="formMessage" placeholder="e.g. Looking for someone fun..."
      rows="2"></textarea>
  </div>
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label">Order</label>
      <input type="number" class="form-control" [(ngModel)]="formOrder" placeholder="e.g. 1" min="0" oninput="this.value = Math.abs(this.value)" />
    </div>
    <div class="col-6">
      <label class="form-label">Weight</label>
      <select class="form-select" [(ngModel)]="formWeight">
        <option value="" disabled>Select weight</option>
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
      </select>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-6">
      <label class="form-label">Category</label>
      <select class="form-select" [(ngModel)]="formCategory">
        <option value="" disabled>Select category</option>
        <option value="onboarding">Onboarding</option>
        <option value="auth">Auth</option>
        <option value="landing">Landing</option>
        <option value="advertisment">Advertisment</option>
      </select>
    </div>
    <div class="col-6">
      <label class="form-label">Image Type</label>
      <select class="form-select" [(ngModel)]="formImageType" (ngModelChange)="onImageTypeChange()">
        <option value="" disabled>Select type</option>
        <option value="circle">Circle</option>
        <option value="square">Square</option>
      </select>
    </div>
  </div>

  <input #fileInput type="file" accept="image/*" class="d-none" (change)="onFileSelected($event)" />

  <!-- ADDED: Toggle Checkbox Option -->
  @if (!croppedPreviewUrl && !showCropper) {
    <div class="form-check form-switch mb-3">
      <input class="form-check-input" type="checkbox" id="skipCropToggle" [(ngModel)]="skipCropping">
      <label class="form-check-label fw-medium" for="skipCropToggle">
        Skip cropping and upload raw file directly
      </label>
    </div>
  }

  @if (!showCropper && !croppedPreviewUrl) {
  <div class="mb-3">
    <label class="form-label">Image</label>
    <div class="upload-area" (click)="triggerFileInput()">
      <i class="fa-light fa-cloud-arrow-up upload-icon"></i>
      <p class="mb-1 mt-2 fw-semibold">Click to upload image</p>
      <small class="text-muted">PNG, JPG, WEBP supported</small>
    </div>
  </div>
  }

  @if (showCropper && cropImgSrc) {
  <div class="mb-3">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <label class="form-label mb-0">Crop Image</label>
      <small class="text-muted">Drag to move · Drag corners to resize</small>
    </div>
    <div class="cropper-wrapper">
      <canvas #cropCanvas width="480" height="320" class="crop-canvas" (mousedown)="onCanvasMouseDown($event)"
        (mousemove)="onCanvasMouseMove($event)" (mouseup)="onCanvasMouseUp()" (mouseleave)="onCanvasMouseUp()">
      </canvas>
    </div>
    <div class="text-end mt-2">
      <button class="btn-light border me-2 btn-sm" (click)="removeImage()">
        Cancel
      </button>
      <button class="btn btn-outline-secondary me-2 btn-sm" (click)="disableCroppingAction()">
        Disable Cropping
      </button>
      <button class="btn btn-primary btn-sm" (click)="applyCrop()">
        <i class="fa-solid fa-check me-1"></i> Apply Crop
      </button>
    </div>
  </div>
  }

  @if (!showCropper && croppedPreviewUrl) {
  <div class="mb-3">
    <label class="form-label">Preview</label>
    <div class="d-flex align-items-center gap-3">
      <div style="position: relative; display: inline-block;">
        <img [src]="croppedPreviewUrl" alt="Preview" class="preview-thumb-lg"
          [class.circle-thumb]="formImageType === 'circle'" style="cursor: pointer;"
          (click)="openImageInNewTab()" title="Click to view in new tab" />
        <button class="btn-close"
          style="position: absolute; top: -6px; right: -6px; background-color: #fff; border-radius: 50%; box-shadow: 0 1px 4px rgba(0,0,0,0.2); padding: 4px;"
          (click)="removeImage()">
        </button>
      </div>
      <div class="d-flex flex-column gap-2">
        <!-- MODIFIED: Conditionally show re-crop button based on choice -->
        @if (!skipCropping) {
          <button class="btn btn-outline-secondary btn-sm" (click)="reCrop()">
            <i class="fa-solid fa-crop me-1"></i> Re-crop
          </button>
        }
        <button class="btn btn-outline-secondary btn-sm" (click)="triggerFileInput()">
          <i class="fa-solid fa-upload me-1"></i> New Image
        </button>
      </div>
    </div>
  </div>
  }

</div>

<div class="modal-footer-row">
  <button class="btn btn-light border me-2" (click)="cancel()">Cancel</button>
  <button class="btn btn-primary" (click)="save()" [disabled]="isSaving || !isFormValid()">
    @if (isSaving) { <i class="fa-solid fa-spinner fa-spin me-2"></i> }
    {{ editingImage ? 'Update' : 'Save' }}
  </button>
</div>
